export class AliquotaIbsEditDialogData {
    titulo: string;
    descricao: string;
    pAliquota: number;
}
